import { zodResolver } from '@hookform/resolvers/zod';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
// import { Eye as EyeIcon } from '@phosphor-icons/react/dist/ssr/Eye';
// import { EyeSlash as EyeSlashIcon } from '@phosphor-icons/react/dist/ssr/EyeSlash';
import { Controller, useForm } from 'react-hook-form';
import { z as zod } from 'zod';
import { useWeb3 } from '@/hooks/use-web3';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { loginAdmin, otpLogin } from '@/api/asset/admin/read';
import { toast } from 'react-toastify';
import { Box, Input } from '@mui/material';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { walletState } from '@/atom/wallet';

import packageJson from '../../../package.json';
import OtpLoginPage from '@/component/otp';
import OtpQrCode from '@/component/otp/OtpQrCode';
import { SUCCESS } from '@/lib/common/name-space';
import { CreateOtpType, ResCreateOtpDto } from '@/types';
const schema = zod.object({
  id: zod.string().min(1, { message: 'Click connect wallet' }),
});

type Values = zod.infer<typeof schema>;

const defaultValues = { id: '' } satisfies Values;
interface OtpLoginResponse {
  qrUrl: string;
  secret: string;
}

export function SignIn() {
  const [showPassword, setShowPassword] = useState<boolean>();
  const [otpCode, setOtpCode] = useState<string>('');
  const [isPending, setIsPending] = useState<boolean>(false);
  const [isOtpEnabled, setIsOtpEnabled] = useState<number>(-1);
  const [otpData, setOtpData] = useState<OtpLoginResponse | null>(null);
  const [, setWallet] = useRecoilState(walletState);
  const navigate = useNavigate();

  const {
    control,
    handleSubmit,
    setError,
    setValue,
    formState: { errors },
  } = useForm<Values>({ defaultValues, resolver: zodResolver(schema) });

  const onSubmit = async (data: Values) => {
  
    const createOtpType: CreateOtpType = {
      id: data.id,
    };
    const re = await otpLogin(createOtpType);
    console.log(re);
    if (re.status !== SUCCESS) {
      return;
    }
    const otpData: ResCreateOtpDto = re.data;
    console.log(otpData);
    if (otpData.otpEnabled === 0) {
      setOtpData(otpData);
      setIsOtpEnabled(otpData.otpEnabled);
    }
    if (otpData.otpEnabled === 1) {
      setIsOtpEnabled(otpData.otpEnabled);
    }
  };

  // const onSubmit = useCallback(
  //   async (values: Values): Promise<void> => {
  //     // setIsPending(true);
  //     await authClient.signInWithPassword(values);

  //     // // Refresh the auth state
  //     await checkSession?.();

  //     // // UserProvider, for this case, will not refresh the router
  //     // // After refresh, GuestGuard will handle the redirect
  //     router.refresh();
  //   },
  //   [checkSession, router, setError],
  // );

  return (
    <Box
      sx={{
        display: 'flex',
        overflow: 'auto',
        flex: 1,
        flexDirection: 'column',
        gap: { xs: '16px', sm: '0px' },
      }}
    >
      <Stack spacing={4}>
        <Stack spacing={1}>
          <Typography variant="h4">Sign in</Typography>
          <Typography color="text.secondary" variant="body2">
            Dont have an account?{' '}
            <Button
              variant="text"
              onClick={() => {
                navigate('/sign-up');
              }}
            >
              Sign up
            </Button>
            {/* <Link component={RouterLink} href={paths.auth.signUp} underline="hover" variant="subtitle2">
              Sign up
            </Link> */}
          </Typography>
          {/* <Typography color="text.secondary" variant="body2">
          disconnect wallet?
          <Button
            onClick={async () => {
              if (web3authCall?.connected()) {
                await web3authCall?.logout();
              }
              window.location.reload();
            }}
          >
            disconnect
          </Button>
        </Typography> */}
        </Stack>
        {isOtpEnabled === -1 ? (
          <form onSubmit={handleSubmit(onSubmit)}>
            <Stack spacing={2}>
              {/* <Button
            color="info"
            type="button"
            variant="contained"
            onClick={async () => {
              const re = await web3authCall?.getWeb3auth().connect();
              console.log(re);
              if (re) {
                const userAccount = await web3authCall?.getAddress();
                console.log(userAccount);
                userAccount && setValue('id', userAccount);
              }
            }}
          >
            Connect Wallet
          </Button> */}
              <Controller
                control={control}
                name="id"
                render={({ field }) => (
                  <FormControl error={Boolean(errors.id)}>
                    <InputLabel>id</InputLabel>
                    <OutlinedInput {...field} label="id" type="text" />
                    {errors.id ? <FormHelperText>{errors.id.message}</FormHelperText> : null}
                  </FormControl>
                )}
              />
              <div>
                {/* <Link component={RouterLink} href={paths.auth.resetPassword} variant="subtitle2">
              Forgot password?
            </Link> */}
              </div>
              {errors.root ? <Alert color="error">{errors.root.message}</Alert> : null}
              <Button disabled={isPending} type="submit" variant="contained">
                Sign in
              </Button>
            </Stack>
          </form>
        ) : (
          <OtpLoginPage isOtpEnabled={isOtpEnabled} otpData={otpData} id={control._formValues.id} />
        )}
        <br />
        {/* {isOtpEnabled !== -1 && <OtpLoginPage isOtpEnabled={isOtpEnabled} otpData={otpData} />} */}
        {packageJson.version}
        <Input type="text" value={otpCode} onChange={(e: any) => setOtpCode(e.target.value)} />
      </Stack>
    </Box>
  );
}
